import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = {
  id: "sketchfab",
  class: "mt-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "sketch fab!", -1)
const _hoisted_6 = { class: "d-flex justify-content-between my-2" }
const _hoisted_7 = { class: "row gy-3" }
const _hoisted_8 = { class: "d-flex justify-content-between my-2" }

import { onMounted, ref } from "vue";
import axios from "axios";
import { DialogHandler } from "../DialogHandler";
import CoreDialog from "../../../../framework/components/dialog/CoreDialog.vue";
import Loading from "../../common/LoadingView.vue";
import { translation } from "../../../lang/Translation";
import SketchFabCardSection from "./section/SketchFabCardSection.vue";
import { SketchFabResult } from "./model/SketchFabResult";
import { SketchFabResponse } from "./model/SketchFabResponse";


export default /*#__PURE__*/_defineComponent({
  __name: 'SketchFabListDialog',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-explicit-any */
const t = translation;
const title = ref(t.to("Sketchfabモデルリスト", "sketch_fab_list"));

const modelList = ref([] as SketchFabResult[]);
const dialogId = DialogHandler.sketchFabListDialogId;

const hasPrev = ref(false);
const hasNext = ref(false);
const prevUrl = ref("");
const nextUrl = ref("");
const loading = ref(false);

function setResult(resp: SketchFabResponse) {
  hasPrev.value = !!resp.cursors.previous;
  hasNext.value = !!resp.cursors.next;
  nextUrl.value = resp.next;
  prevUrl.value = resp.previous;
  modelList.value = resp.results;
}
/**
 * Sketch Fab を検索
 */
const searchSKetchFab = async (keywords, size, self) => {
  // console.log('searchSKetchFab', size, self);
  modelList.value = [];
  let url = `https://api.sketchfab.com/v3/search?type=models&file_format=glb&file_format=gltf&downloadable=true`;
  if (keywords) url += `&q=${keywords}`;
  const response = await axios.get(url);
  setResult(response.data);
};

const toNextPage = async () => {
  const response = await axios.get(nextUrl.value);
  setResult(response.data);
};
const toPrevPage = async () => {
  const response = await axios.get(prevUrl.value);
  setResult(response.data);
};

/**
 * 表示カウントを取得
 */
const getDisplayCount = () => {
  return 20;
};

/**
 * モーダルを開いた時にSkechfabからデータを取る
 */
const lastSearchWord = ref("");
onMounted(() => {
  if (!lastSearchWord.value) {
    lastSearchWord.value = "VR";
  }

  DialogHandler.onOpenDialog(dialogId, function () {
    searchSKetchFab(lastSearchWord.value, getDisplayCount(), this).then();
  });
});

const findSketchFab = async () => {
  // console.log('findScetchFab', lastSearchWord.value);
  await searchSKetchFab(lastSearchWord.value, getDisplayCount(), this);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-xl': true, 'modal-fullscreen-lg-down': true },
    title: title.value
  }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createBlock(Loading, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("fieldset", null, [
              _withDirectives(_createElementVNode("input", {
                id: "search_word",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((lastSearchWord).value = $event)),
                name: "search_word",
                type: "text",
                class: "input mx-2"
              }, null, 512), [
                [_vModelText, lastSearchWord.value]
              ]),
              _createElementVNode("span", null, [
                _createElementVNode("button", {
                  class: "btn btn-outline-dark btn-sm",
                  onClick: findSketchFab
                }, _toDisplayString(_unref(t).to("検索", "sf_find")), 1),
                _createTextVNode(" " + _toDisplayString(_unref(t).to("アルファベットで検索(例: RED)", "sf_comment")), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-primary", { disabled: !hasPrev.value }]),
              onClick: toPrevPage
            }, " Prev ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-primary", { disabled: !hasNext.value }]),
              onClick: toNextPage
            }, " Next ", 2)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (modelList.value.length === 0)
              ? (_openBlock(), _createBlock(Loading, { key: 0 }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelList.value, (asset) => {
              return (_openBlock(), _createElementBlock("div", {
                key: asset.name,
                class: "col-md-3"
              }, [
                _createVNode(SketchFabCardSection, { asset: asset }, null, 8, ["asset"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-primary", { disabled: !hasPrev.value }]),
              onClick: toPrevPage
            }, " Prev ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-primary", { disabled: !hasNext.value }]),
              onClick: toNextPage
            }, " Next ", 2)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})